// ------------------------------------
// Constants
// ------------------------------------
export const DPC_PROFILES_GET_REQUEST = "DPC_PROFILES_GET_REQUEST";
export const DPC_PROFILES_GET_REQUEST_SUCCESS =
  "DPC_PROFILES_GET_REQUEST_SUCCESS";
export const DPC_PROFILES_GET_REQUEST_FAILURE =
  "DPC_PROFILES_GET_REQUEST_FAILURE";
export const DPC_PROFILES_GET_RESET = "DPC_PROFILES_GET_RESET";

// ------------------------------------
// Actions
// ------------------------------------
export function request() {
  return {
    type: DPC_PROFILES_GET_REQUEST,
  };
}

export function requestSuccess(data) {
  return {
    type: DPC_PROFILES_GET_REQUEST_SUCCESS,
    data,
  };
}

export function requestFailure(error) {
  return {
    type: DPC_PROFILES_GET_REQUEST_FAILURE,
    error,
  };
}

export function reset() {
  return {
    type: DPC_PROFILES_GET_RESET,
  };
}
